import type { IconSvgObject } from './types';

const Wifi01Icon: IconSvgObject = [
  ["path", { d: "M8 14.5C10 12.5 14 12.5 16 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 11.5C14.7324 8.16667 9.5 8.16667 5.5 11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 8.5C8.31579 3.16669 15.6842 3.16668 22 8.49989", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "12", cy: "18", r: "1.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Wifi01Icon;
